export const getCookies = () => {
  return document.cookie;
};
